/**
 * Verticaly 3.0 - Theater Mode Enhanced
 * 世界一のUI - シアターモード機能強化
 * 2025-11-19
 */

(function() {
  'use strict';

  // Theater Mode が有効化されているか確認
  function isTheaterModeActive() {
    return document.body.classList.contains('theater-mode-active') ||
           document.querySelector('.modal--active') !== null ||
           document.querySelector('[data-theater-mode="true"]') !== null ||
           document.querySelector('.v0-theater-modal.active') !== null;
  }

  // Floating Controls（TikTokスタイル）を作成
  function createFloatingControls(videoContainer) {
    // 既存のコントロールをチェック
    if (videoContainer.querySelector('.theater-floating-controls')) {
      return;
    }

    const controls = document.createElement('div');
    controls.className = 'theater-floating-controls';
    controls.innerHTML = `
      <button class="theater-control-btn" data-action="like" aria-label="いいね">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
        </svg>
      </button>
      <button class="theater-control-btn" data-action="download" aria-label="ダウンロード">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="7 10 12 15 17 10"></polyline>
          <line x1="12" y1="15" x2="12" y2="3"></line>
        </svg>
      </button>
      <button class="theater-control-btn" data-action="share" aria-label="シェア">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
          <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
        </svg>
      </button>
    `;

    videoContainer.appendChild(controls);

    // イベントリスナー追加
    controls.querySelectorAll('.theater-control-btn').forEach(btn => {
      btn.addEventListener('click', handleControlAction);
    });
  }

  // Instant Grading Controls を作成
  function createGradingControls(videoContainer) {
    // 既存のグレーディングコントロールをチェック
    if (videoContainer.querySelector('.theater-grading-controls')) {
      return;
    }

    const grading = document.createElement('div');
    grading.className = 'theater-grading-controls';
    grading.innerHTML = `
      <div class="grading-title">Filter</div>
      <button class="grading-btn" data-filter="none" aria-label="フィルターなし">
        <span class="grading-label">Original</span>
      </button>
      <button class="grading-btn" data-filter="cinema" aria-label="シネマフィルター">
        <span class="grading-label">Cinema</span>
      </button>
      <button class="grading-btn" data-filter="vivid" aria-label="ビビッドフィルター">
        <span class="grading-label">Vivid</span>
      </button>
      <button class="grading-btn" data-filter="bw" aria-label="白黒フィルター">
        <span class="grading-label">B&W</span>
      </button>
    `;

    videoContainer.appendChild(grading);

    // イベントリスナー追加
    grading.querySelectorAll('.grading-btn').forEach(btn => {
      btn.addEventListener('click', handleGradingFilter);
    });
  }

  // コントロールアクション処理
  function handleControlAction(e) {
    e.preventDefault();
    e.stopPropagation();

    const btn = e.currentTarget;
    const action = btn.dataset.action;

    // アニメーション効果
    btn.style.transform = 'scale(0.9)';
    setTimeout(() => {
      btn.style.transform = '';
    }, 150);

    switch(action) {
      case 'like':
        // いいね機能（既存のシステムと統合）
        const likeBtn = document.querySelector('[data-action="favorite"]');
        if (likeBtn) likeBtn.click();
        break;
      case 'download':
        // ダウンロード機能（既存のシステムと統合）
        const downloadBtn = document.querySelector('[data-action="download"]');
        if (downloadBtn) downloadBtn.click();
        break;
      case 'share':
        // シェア機能 - モーダルのシェア関数を直接呼び出す
        if (typeof window.handleModalShare === 'function') {
          window.handleModalShare();
        } else if (typeof handleModalShare === 'function') {
          handleModalShare();
        } else {
          // フォールバック: currentProductDataから直接URLを生成
          if (window.currentProductData && window.currentProductData.handle) {
            const shareUrl = `${window.location.origin}/products/${window.currentProductData.handle}?modal=true`;
            navigator.clipboard.writeText(shareUrl).then(() => {
              if (typeof showNotification === 'function') {
                showNotification('リンクをコピーしました', 'success');
              } else if (typeof window.showNotification === 'function') {
                window.showNotification('リンクをコピーしました', 'success');
              }
              // ボタンの視覚的フィードバック
              btn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg>';
              btn.style.backgroundColor = '#10b981';
              setTimeout(() => {
                btn.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path></svg>`;
                btn.style.backgroundColor = '';
              }, 2000);
            });
          }
        }
        break;
    }
  }

  // グレーディングフィルター処理
  function handleGradingFilter(e) {
    e.preventDefault();
    e.stopPropagation();

    const btn = e.currentTarget;
    const filter = btn.dataset.filter;
    const video = document.querySelector('.theater-mode-active video, .modal--active video');

    if (!video) return;

    // すべてのボタンからactiveクラスを削除
    document.querySelectorAll('.grading-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    // フィルタークラスをリセット
    video.classList.remove('filter-cinema', 'filter-vivid', 'filter-bw');

    // 新しいフィルターを適用
    if (filter !== 'none') {
      video.classList.add(`filter-${filter}`);
    }

    // アニメーション効果
    btn.style.transform = 'scale(0.95)';
    setTimeout(() => {
      btn.style.transform = '';
    }, 100);
  }

  // Theater Mode監視
  function observeTheaterMode() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' || mutation.type === 'childList') {
          // v0-theater-modal.active を優先的に検出
          const modal = document.querySelector('.v0-theater-modal.active, .modal--active, [data-theater-mode="true"]');
          if (modal) {
            // v0-theater-modal の場合は .v0-card__media（親コンテナ）を検索
            // .v0-card__video は VIDEO 要素自体なので、親の .v0-card__media を使用
            const videoContainers = modal.querySelectorAll('.v0-card__media, .modal__video-container, .video-container');
            videoContainers.forEach(container => {
              if (!container.querySelector('.theater-floating-controls')) {
                createFloatingControls(container);
                createGradingControls(container);
              }
            });
          }
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-theater-mode']
    });
  }

  // 初期化
  function init() {
    // すでに Theater Mode が有効な場合（v0-theater-modal.active を優先）
    const modal = document.querySelector('.v0-theater-modal.active, .modal--active, [data-theater-mode="true"]');
    if (modal) {
      // .v0-card__media（親コンテナ）を使用
      const videoContainers = modal.querySelectorAll('.v0-card__media, .modal__video-container, .video-container');
      videoContainers.forEach(container => {
        if (!container.querySelector('.theater-floating-controls')) {
          createFloatingControls(container);
          createGradingControls(container);
        }
      });
    }

    // 今後の Theater Mode 変化を監視
    observeTheaterMode();
  }

  // Theater ボタンクリック時にコントロールを追加
  function setupTheaterButtonListener() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('button');
      if (btn && btn.textContent.trim() === 'Theater') {
        // Theater モードが開くまで少し待ってからコントロールを追加
        setTimeout(() => {
          addControlsToTheaterModal();
        }, 300);
        setTimeout(() => {
          addControlsToTheaterModal();
        }, 600);
      }
    });
  }

  // シアターモーダルにコントロールを追加
  function addControlsToTheaterModal() {
    const modal = document.querySelector('.v0-theater-modal.active');
    if (!modal) return;

    const videoContainers = modal.querySelectorAll('.v0-card__media');
    videoContainers.forEach(container => {
      if (!container.querySelector('.theater-floating-controls')) {
        // position: relative を確保
        container.style.position = 'relative';
        createFloatingControls(container);
        createGradingControls(container);
      }
    });
  }

  // DOMContentLoaded後に初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init();
      setupTheaterButtonListener();
    });
  } else {
    init();
    setupTheaterButtonListener();
  }

  // ==========================================
  // トップページグリッドのホバーコントロール
  // ==========================================

  // 各カードにホバーコントロールを追加
  function addHoverControlsToCards() {
    const cards = document.querySelectorAll('.v0-card, .v0-featured-collection__video, .category-video-card, .category-video-wrapper, .video-card, [class*="video-grid"] [class*="card"]');

    cards.forEach(card => {
      // 既に追加済みの場合はスキップ
      if (card.querySelector('.v0-card__hover-controls')) {
        return;
      }

      const video = card.querySelector('video');
      if (!video) return;

      // ホバーコントロールを作成
      const hoverControls = document.createElement('div');
      hoverControls.className = 'v0-card__hover-controls';
      hoverControls.innerHTML = `
        <button class="v0-card__hover-btn" data-action="audio" aria-label="オーディオ切替">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
            <path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path>
            <path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>
          </svg>
          <span>Audio</span>
        </button>
        <button class="v0-card__hover-btn" data-action="overlay" aria-label="情報オーバーレイ">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="16" x2="12" y2="12"></line>
            <line x1="12" y1="8" x2="12.01" y2="8"></line>
          </svg>
          <span>Info</span>
        </button>
        <button class="v0-card__hover-btn" data-action="theater" aria-label="シアターモード">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M4 3h16a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"></path>
            <polyline points="10 9 15 12 10 15 10 9"></polyline>
          </svg>
          <span>Theater</span>
        </button>
        <button class="v0-card__hover-btn" data-action="cinema" aria-label="シネマフィルター">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
            <path d="M2 17l10 5 10-5"></path>
            <path d="M2 12l10 5 10-5"></path>
          </svg>
          <span>Cinema</span>
        </button>
        <button class="v0-card__hover-btn" data-action="vivid" aria-label="ビビッドフィルター">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <circle cx="12" cy="12" r="3"></circle>
          </svg>
          <span>Vivid</span>
        </button>
      `;

      card.appendChild(hoverControls);

      // イベントリスナー追加
      hoverControls.querySelectorAll('.v0-card__hover-btn').forEach(btn => {
        btn.addEventListener('click', (e) => handleCardHoverControl(e, card, video));
      });
    });
  }

  // カードのホバーコントロール処理
  function handleCardHoverControl(e, card, video) {
    e.preventDefault();
    e.stopPropagation();

    const btn = e.currentTarget;
    const action = btn.dataset.action;

    // アニメーション効果
    btn.style.transform = 'scale(0.9)';
    setTimeout(() => {
      btn.style.transform = '';
    }, 100);

    switch(action) {
      case 'audio':
        // オーディオのオン/オフ切替
        video.muted = !video.muted;
        btn.classList.toggle('active');
        if (!video.muted) {
          // 他のすべての動画をミュートにする
          document.querySelectorAll('video').forEach(v => {
            if (v !== video) v.muted = true;
          });
        }
        break;

      case 'overlay':
        // 情報オーバーレイの表示切替
        const overlay = card.querySelector('.v0-card__overlay, .v0-card__info');
        if (overlay) {
          btn.classList.toggle('active');
          if (btn.classList.contains('active')) {
            overlay.style.opacity = '1';
            overlay.style.transform = 'translateY(0)';
          } else {
            overlay.style.opacity = '0';
            overlay.style.transform = 'translateY(10px)';
          }
        }
        break;

      case 'theater':
        // シアターモード（モーダル）を開く
        card.click(); // カードのクリックイベントをトリガー
        break;

      case 'cinema':
        // シネマフィルター適用
        video.classList.remove('filter-vivid', 'filter-bw');
        btn.classList.toggle('active');

        // 他のフィルターボタンを非アクティブ化
        card.querySelectorAll('[data-action="vivid"]').forEach(b => b.classList.remove('active'));

        if (btn.classList.contains('active')) {
          video.classList.add('filter-cinema');
        } else {
          video.classList.remove('filter-cinema');
        }
        break;

      case 'vivid':
        // ビビッドフィルター適用
        video.classList.remove('filter-cinema', 'filter-bw');
        btn.classList.toggle('active');

        // 他のフィルターボタンを非アクティブ化
        card.querySelectorAll('[data-action="cinema"]').forEach(b => b.classList.remove('active'));

        if (btn.classList.contains('active')) {
          video.classList.add('filter-vivid');
        } else {
          video.classList.remove('filter-vivid');
        }
        break;
    }
  }

  // カードの監視（動的に追加されるカードにも対応）
  function observeCards() {
    const observer = new MutationObserver(() => {
      addHoverControlsToCards();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // 初期化（ページロード時）
  function initHoverControls() {
    addHoverControlsToCards();
    observeCards();
  }

  // DOMContentLoaded後に初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverControls);
  } else {
    initHoverControls();
  }

})();
